import { createContext, useContext, useState } from 'react';
import { ContextProviderProps } from './interfaces';
import config from '../config/config';

/* Context for holding routenames that are set in brand configs (in app.tsx) */

interface Routes {
    main: string,
    form: string,
    doctorMain: string,
    doctorApproval: string,
    profile: string,
    admin: string
};

interface RoutesContextType {
    routes: Routes,
    setRoutes: (val: Routes) => void;
};

export const RoutesContext = createContext({} as RoutesContextType);
export const useRoutesContext = () => useContext(RoutesContext);

export const RoutesContextProvider = ({ children }: ContextProviderProps) => {
    const [routes, setRoutes] = useState<Routes>(config.routes);
    return <RoutesContext.Provider value={{ routes, setRoutes }}>
        {children}
    </RoutesContext.Provider>
};